import { EMPTY_LIST } from '../../../constants/common'
import { PAGINATION_DEFAULT_PAGE_SIZE } from '../../../constants/pagination'
import { FORMIK_EMPTY_VALUE } from '../../../constants/validation'

export const EMAIL_CREATION_FORM_FIELD_NAME_FROM = 'account'

export const EMAIL_CREATION_FORM_FIELD_NAME_REPLY_TO = 'reply_to'

export const EMAIL_CREATION_FORM_FIELD_NAME_REPLY_SUBJECT = 'reply_subject' // service field

export const EMAIL_CREATION_FORM_FIELD_NAME_REPLY_TEXT = 'reply_text' // service field

export const EMAIL_CREATION_FORM_FIELD_NAME_TO = 'to'

export const EMAIL_CREATION_FORM_FIELD_NAME_CC = 'cc'

export const EMAIL_CREATION_FORM_FIELD_NAME_BCC = 'bcc'

export const EMAIL_CREATION_FORM_FIELD_NAME_SUBJECT = 'title'

export const EMAIL_CREATION_FORM_FIELD_NAME_TEMPLATE = 'template'

export const EMAIL_CREATION_FORM_FIELD_NAME_MESSAGE = 'text'

export const EMAIL_CREATION_FORM_FIELD_NAME_PRINTER = 'printer'

export const EMAIL_CREATION_FORM_FIELD_NAME_PRIORITY = 'is_high_priority'

export const EMAIL_CREATION_FORM_FIELD_NAME_THREAD = 'thread'

export const EMAIL_CREATION_FORM_FIELD_NAME_DOCUMENTS_TEMPLATES =
  'documents_templates'

export const EMAIL_CREATION_FORM_FIELD_NAME_FILES_FROM_STORAGE =
  'files_from_storage'

export const EMAIL_CREATION_FORM_FIELD_NAME_FILES = 'files'

export const EMAIL_CREATION_FORM_FIELD_NAME_FILES_AS_LINKS = 'files_as_links'

export const EMAIL_CREATION_FORM_FIELD_NAME_MASS_MAILING = 'mass_mailing'

export const EMAIL_CREATION_FORM_FIELD_NAME_SELECTED_TEMPLATE =
  'template_selected'

export const EMAIL_CREATION_FORM_FIELD_NAME_SELECTED_TEMPLATE_FILES =
  'template_files_selected'

export const EMAIL_CREATION_FORM_FIELD_NAME_SIGNATURE = 'signature'

export const EMAIL_CREATION_FORM_SEPARATE = 'separate_messages'

export const EMAIL_CREATION_FORM_FIELD_NAME_DELETE_EMPTY_EMAIL_USERS =
  'delete_empty_email_users'

export const EMAIL_CREATION_FORM_FIELD_NAME_HAS_NO_EMAIL_ACCOUNTS =
  'has_no_email_accounts'

export const EMAIL_CREATION_FORM_INITIAL_VALUES_TO = {
  [EMAIL_CREATION_FORM_FIELD_NAME_TO]: EMPTY_LIST,
}

export const EMAIL_CREATION_FORM_INITIAL_VALUES = {
  [EMAIL_CREATION_FORM_FIELD_NAME_FROM]: FORMIK_EMPTY_VALUE,
  ...EMAIL_CREATION_FORM_INITIAL_VALUES_TO,
  [EMAIL_CREATION_FORM_FIELD_NAME_BCC]: EMPTY_LIST,
  [EMAIL_CREATION_FORM_FIELD_NAME_CC]: EMPTY_LIST,
  [EMAIL_CREATION_FORM_FIELD_NAME_DOCUMENTS_TEMPLATES]: EMPTY_LIST,
  [EMAIL_CREATION_FORM_FIELD_NAME_FILES]: EMPTY_LIST,
  [EMAIL_CREATION_FORM_FIELD_NAME_FILES_AS_LINKS]: EMPTY_LIST,
  [EMAIL_CREATION_FORM_FIELD_NAME_FILES_FROM_STORAGE]: EMPTY_LIST,
  [EMAIL_CREATION_FORM_FIELD_NAME_HAS_NO_EMAIL_ACCOUNTS]: false,
  [EMAIL_CREATION_FORM_FIELD_NAME_MASS_MAILING]: false,
  [EMAIL_CREATION_FORM_FIELD_NAME_MESSAGE]: FORMIK_EMPTY_VALUE,
  [EMAIL_CREATION_FORM_FIELD_NAME_PRINTER]: FORMIK_EMPTY_VALUE,
  [EMAIL_CREATION_FORM_FIELD_NAME_PRIORITY]: false,
  [EMAIL_CREATION_FORM_FIELD_NAME_REPLY_SUBJECT]: FORMIK_EMPTY_VALUE,
  [EMAIL_CREATION_FORM_FIELD_NAME_REPLY_TEXT]: FORMIK_EMPTY_VALUE,
  [EMAIL_CREATION_FORM_FIELD_NAME_REPLY_TO]: FORMIK_EMPTY_VALUE,
  [EMAIL_CREATION_FORM_FIELD_NAME_SELECTED_TEMPLATE]: null,
  [EMAIL_CREATION_FORM_FIELD_NAME_SELECTED_TEMPLATE_FILES]: null,
  [EMAIL_CREATION_FORM_FIELD_NAME_SIGNATURE]: FORMIK_EMPTY_VALUE,
  [EMAIL_CREATION_FORM_FIELD_NAME_SUBJECT]: FORMIK_EMPTY_VALUE,
  [EMAIL_CREATION_FORM_FIELD_NAME_TEMPLATE]: FORMIK_EMPTY_VALUE,
}

export const EMAIL_CREATION_FORM_ACCOUNT_API_PARAMS = { is_active: true }

export const EMAIL_CREATION_FORM_ACCOUNT_MASS_API_PARAMS = {
  ...EMAIL_CREATION_FORM_ACCOUNT_API_PARAMS,
  info: true,
}

export const EMAIL_CREATION_FORM_ACCOUNT_SERVICE_API_PARAMS = {
  ...EMAIL_CREATION_FORM_ACCOUNT_API_PARAMS,
  service: true,
}

export const EMAIL_CREATION_FORM_TEMPLATE_API_PARAMS = {
  hidden: false,
  ordering: 'name',
  page_size: PAGINATION_DEFAULT_PAGE_SIZE,
  tag: 'email',
}

export const EMAIL_CREATION_FORM_TEMPLATE_MASS_API_PARAMS = {
  ...EMAIL_CREATION_FORM_TEMPLATE_API_PARAMS,
  tag: 'mass_emailing',
}

export const EMAIL_CREATION_FORM_TEMPLATE_REQUEST_THREAD_API_PARAMS = {
  ...EMAIL_CREATION_FORM_TEMPLATE_API_PARAMS,
  tag: 'requestthread_email',
}

export const EMAIL_CREATION_FORM_MAX_INPUT_LENGTH = 256

export const EMAIL_CREATION_FORM_WYSIWYG_MIN_HEIGHT = 312

export const EMAIL_CREATION_FORM_WYSIWYG_MAX_HEIGHT = 327

export const EMAIL_CREATION_FORM_FIELD_NAME_INSERT_REPLACE =
  'insertReplaceTemplate'

export const EMAIL_CREATION_FORM_FIELD_NAME_TEXT_OR_GOOGLE_TEMPLATE =
  'insertReplaceTemplate'

export const EMAIL_CREATION_FORM_NEED_RECONNECT_ACCOUNT = 'needReconnect'

export const EMAIL_CREATION_FORM_RECIPIENTS_TOTAL_LIMIT_NOTIFICATION =
  'recipientsTotalLimit'

export const EMAIL_CREATION_FORM_RECIPIENTS_FIELD_LIMIT_NOTIFICATION =
  'recipientsFieldLimit'

export const EMAIL_CREATION_FORM_RECIPIENTS_TOTAL_MAX_COUNT = 100

export const EMAIL_CREATION_FORM_RECIPIENTS_FIELD_MAX_COUNT = 50

export const EMAIL_CREATION_FORM_TO_FIELD_MIN_COUNT = 1

export const EMAIL_CREATION_FORM_NOTIFICATION_NO_ACTIVE_ACCOUNTS =
  'noActiveAccount'

export const EMAIL_CREATION_FORM_BLACK_LIST_API_PARAM = 'emails'

export const EMAIL_CREATION_FORM_NOTIFICATION_HAS_BLACK_LIST_ACCOUNTS =
  'hasBlackList'

export const EMAIL_CREATION_FORM_NOTIFICATION_BLACK_LIST_CHECK_SERVER_ERROR =
  'BlackListServerError'

export const EMAIL_CREATION_FORM_NOTIFICATION_HAS_NO_EMAIL_ACCOUNTS =
  'noEmailAccounts'

export const EMAIL_CREATION_FORM_NOTIFICATION_CC_BCC_MASS_MAILING_INFO =
  'ccBccMassInfo'

export const EMAIL_CREATION_FORM_NOTIFICATION_AI_DRAFT_NOT_APPLIED =
  'aiDraftNotApplied'

export const EMAIL_CREATION_FORM_NOTIFICATION_DUPLICATE_RECIPIENTS =
  'duplicateRecipients'

export const EMAIL_CREATION_FORM_TEST_VARIABLES_STATUS_INTERVAL = 1000

export const EMAIL_CREATION_FORM_TEST_VARIABLES_STATUS_PENDING = 'PENDING'

export const EMAIL_CREATION_FORM_TEST_VARIABLES_STATUS_STARTED = 'STARTED'

export const EMAIL_CREATION_FORM_ACTION_ATTACH_FILE = 'attach_file'

export const EMAIL_CREATION_FORM_ACTION_ATTACH_TEMPLATE = 'attach_template'

export const EMAIL_CREATION_FORM_ACTION_ATTACH_REQUEST_FILE =
  'attach_request_file'

export const EMAIL_CREATION_FORM_TEMPLATE_FOLDER_PRIVATE = 'private'

export const EMAIL_CREATION_FORM_TEMPLATE_FOLDER_MASS = 'mass_emailing'

export const EMAIL_CREATION_FORM_TEMPLATE_FOLDER_REQUEST = 'request'

export const EMAIL_CREATION_FORM_TEMPLATE_FOLDERS = {
  [EMAIL_CREATION_FORM_TEMPLATE_FOLDER_MASS]:
    EMAIL_CREATION_FORM_TEMPLATE_FOLDER_MASS,
  [EMAIL_CREATION_FORM_TEMPLATE_FOLDER_PRIVATE]:
    EMAIL_CREATION_FORM_TEMPLATE_FOLDER_PRIVATE,
  [EMAIL_CREATION_FORM_TEMPLATE_FOLDER_REQUEST]:
    EMAIL_CREATION_FORM_TEMPLATE_FOLDER_REQUEST,
}

export const EMAIL_CREATION_FORM_MIN_HEIGHT_FOR_COLLAPSE_SMALL = 350

export const EMAIL_CREATION_FORM_MIN_HEIGHT_FOR_COLLAPSE_FULL_SCREEN = 530

export const EMAIL_CREATION_FORM_API_KEY_COPY_TO_ARCHIVE = 'copy_to_archive'

export const EMAIL_CREATION_FORM_API_KEY_REPLY_TO_NYLAS = 'reply_to_nylas'

export const EMAIL_CREATION_FORM_API_KEY_SEPARATE_MESSAGES = 'separate_messages'

export const EMAIL_CREATION_FORM_API_KEY_SNIPPET = 'snippet'

export const EMAIL_CREATION_FORM_API_KEY_SNIPPET_DEPENDENCIES =
  'snippet_dependencies'

export const EMAIL_CREATION_FORM_MIN_HEIGHT_FOR_COLLAPSE = {
  fullScreen: EMAIL_CREATION_FORM_MIN_HEIGHT_FOR_COLLAPSE_FULL_SCREEN,
  small: EMAIL_CREATION_FORM_MIN_HEIGHT_FOR_COLLAPSE_SMALL,
}

export const EMAIL_CREATION_FORM_NOTIFICATION_RECIPIENTS_MAX_FIELD_LENGTH =
  'maxRecipientFieldLength'

export const EMAIL_CREATION_FORM_NOTIFICATION_RECIPIENTS_SPECIAL_CHARACTERS =
  'specialCharacters'

export const EMAIL_SPECIAL_CHARACTERS = /[( )<>[\]{}:,“\\]/

export const EMAIL_RECIPIENTS_PRIVATE_NO_SPAM_MAX_COUNT = 24

export const EMAIL_FORM_TEMPLATE_API_PARAM_BUILDING_ID = 'building_id'

export const EMAIL_FORM_TEMPLATE_API_PARAM_FLAT_ID = 'flat_id'

export const EMAIL_FORM_TEMPLATE_API_PARAM_RECIPIENT_ID = 'recipient_id'

export const EMAIL_FORM_TEMPLATE_API_PARAM_REQUEST_ID = 'request_id'

export const EMAIL_FORM_TEMPLATE_API_PARAM_UNTAGGED = 'untagged_only'

export const EMAIL_FORM_TEMPLATE_API_PARAM_REPLACE_UNDEFINED =
  'replace_undefined'

export const EMAIL_FORM_TEMPLATE_DEPENDENCY_API_PARAM_AUTHOR_ID = 'author_id'

export const EMAIL_CREATION_FORM_IS_MASS_MAILING = 'is_mass_mailing'

export const EMAIL_CREATION_FORM_NOTIFICATION_SEPARATE_EMAILS = 'separateEmails'

export const EMAIL_CREATION_FORM_API_FIELDS = [
  EMAIL_CREATION_FORM_API_KEY_REPLY_TO_NYLAS,
  EMAIL_CREATION_FORM_API_KEY_SEPARATE_MESSAGES,
  EMAIL_CREATION_FORM_FIELD_NAME_BCC,
  EMAIL_CREATION_FORM_FIELD_NAME_CC,
  EMAIL_CREATION_FORM_FIELD_NAME_DOCUMENTS_TEMPLATES,
  EMAIL_CREATION_FORM_FIELD_NAME_FROM,
  EMAIL_CREATION_FORM_FIELD_NAME_MESSAGE,
  EMAIL_CREATION_FORM_FIELD_NAME_PRINTER,
  EMAIL_CREATION_FORM_FIELD_NAME_PRIORITY,
  EMAIL_CREATION_FORM_FIELD_NAME_REPLY_TO,
  EMAIL_CREATION_FORM_FIELD_NAME_SUBJECT,
  EMAIL_CREATION_FORM_FIELD_NAME_TO,
]

export const EMAIL_CREATION_FORM_SERVER_ERROR_UNABLE_TO_PERFORM_ACTION =
  'You_do_not_have_permission_to_perform_this_action'

export const EMAIL_CREATION_FORM_SERVER_ERROR_REQUEST_WAS_THROTTLED =
  'RequestWasThrottled'

export const EMAIL_CREATION_FORM_SERVER_ERROR_COPY_TO_ARCHIVE_SEPARATE_MESSAGES =
  "You can't copy to archive and separate messages at the same time"

export const EMAIL_CREATION_FORM_SERVER_ERRORS = {
  [EMAIL_CREATION_FORM_SERVER_ERROR_COPY_TO_ARCHIVE_SEPARATE_MESSAGES]:
    'Error.EmailFormCopyToArchiveSeparateMessagesKey',
  [EMAIL_CREATION_FORM_SERVER_ERROR_REQUEST_WAS_THROTTLED]:
    'Error.EmailFormRequestWasThrottled',
  [EMAIL_CREATION_FORM_SERVER_ERROR_UNABLE_TO_PERFORM_ACTION]:
    'Error.EmailFormUnableToPerformActionKey',
}

export const EMAIL_CREATION_FORM_TO_FIELD_ERROR_INCORRECT_VALUE =
  'to-field-incorrect-value'

export const PRIVATE_ACC_FILE_MAX_SIZE = 20 // mb

export const SYSTEM_ACC_FILE_MAX_SIZE = 10 // mb

export const EMAIL_TABLE_BORDER_COLOR = '#D0D5DD'

export const EMAIL_TABLE_SAFE_BORDER_STYLES = [
  'solid',
  'dashed',
  'dotted',
  'none',
  'hidden',
]

export const EMAIL_TABLE_FORBIDDEN_STYLES = [
  'margin',
  'position',
  'float',
  'display',
  'overflow',
  'z-index',
  'transform',
]

export const EMAIL_CREATION_FORM_RECIPIENT_FIELD_EMAIL_TYPE = {
  additional: 'email',
  main: 'auth-email',
  partner: 'partner-email',
}

export const EMAIL_CREATION_FORM_RECIPIENT_FIELD_EXPAND_API_PARAM = {
  expand: Object.values(EMAIL_CREATION_FORM_RECIPIENT_FIELD_EMAIL_TYPE),
}

export const EMAIL_CREATION_FORM_RECIPIENT_FIELD_NAMES_IN_ORDER = [
  EMAIL_CREATION_FORM_FIELD_NAME_TO,
  EMAIL_CREATION_FORM_FIELD_NAME_CC,
  EMAIL_CREATION_FORM_FIELD_NAME_BCC,
]

export const EMAIL_PREFORMATTED_TAG_NAME = 'pre'

// Tags the backend sanitizer unwraps (keeping their content): converting them
// to <p> upfront, on the frontend, stops their line breaks from being lost.
export const EMAIL_UNWRAPPED_BLOCK_TAGS = [
  'div',
  'section',
  'article',
  'header',
  'footer',
  'main',
  'aside',
  'nav',
  'center',
  'address',
  'figure',
  'figcaption',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  EMAIL_PREFORMATTED_TAG_NAME,
  'dl',
  'dt',
  'dd',
]

export const EMAIL_UNWRAPPED_BLOCK_TAGS_PATTERN = new RegExp(
  `<(?:${EMAIL_UNWRAPPED_BLOCK_TAGS.join('|')})[\\s>]`,
  'i'
)

export const EMAIL_UNWRAPPED_BLOCK_TAGS_SELECTOR =
  EMAIL_UNWRAPPED_BLOCK_TAGS.join(',')

export const EMAIL_BLOCK_CHILD_TAGS = [
  ...EMAIL_UNWRAPPED_BLOCK_TAGS,
  'p',
  'table',
  'ul',
  'ol',
  'li',
  'blockquote',
  'hr',
  'caption',
]

export const EMAIL_BLOCK_CHILD_TAGS_SELECTOR = EMAIL_BLOCK_CHILD_TAGS.join(',')
